import React from "react";
import { RETAIL_URL } from "config/seo/urls";
import { css } from '@emotion/css';
import { Theme } from 'evcharging/app/themes';
import useTheme from 'evcharging/hooks/useTheme';
import { PageLink } from "components/common/atoms";

const items = [
  { url: '/', label: 'Energy5' },
  { url: RETAIL_URL, label: 'Retail Energy', },
  { label: 'Plans' },
];

const RatesBreadcrumbs = () => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root}>
      {items.map((item, index) => (
        item.url ?
          <>
            <PageLink href={item.url} key={index} className={styles.a}>{item.label}</PageLink>
            <span className={styles.slash}>/</span>
          </> :
          <span className={styles.final}>{item.label}</span>
      ))}
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      margin-top: 120px;
      margin-bottom: 30px;
      ${theme.breakpoints.mobile.down} {
        margin-top: 40px;
        margin-bottom: 10px;
      }
    `,
    a: css`
    font-weight: 600;
    font-size: 14px;
    color: #93979B;
  `,
    slash: css`
    font-weight: 600;
    font-size: 14px;
    color: #000;
    padding-left: 8px;
    padding-right: 8px;
  `,
    final: css`
    font-weight: 600;
    font-size: 14px;
    color: #000;
  `,
  }
);

export default RatesBreadcrumbs;